import { DashboardTypeEntity } from '../entities';
import { authResource } from './Auth';
export const AccountDashboardTypeResource = authResource({
    path: '/accounts/:accountId/dashboardtype/:dashboardTypeId?',
    schema: DashboardTypeEntity
});
